// Constantes compartilhadas do módulo Patrimônio (espelham os enums do backend)

export const TIPOS_PATRIMONIO = [
    { value: "EQUIPAMENTO", label: "Equipamento" },
    { value: "VEICULO", label: "Veículo" },
    { value: "IMOVEL", label: "Imóvel" },
    { value: "MOBILIARIO", label: "Mobiliário" },
    { value: "FERRAMENTA", label: "Ferramenta" },
    { value: "SOFTWARE", label: "Software/Licença" },
    { value: "OUTRO", label: "Outro" },
];

export const SITUACOES_PATRIMONIO = [
    { value: "ATIVO", label: "Ativo", color: "#10B981" },
    { value: "EM_MANUTENCAO", label: "Em Manutenção", color: "#F59E0B" },
    { value: "BAIXADO", label: "Baixado", color: "#9CA3AF" },
    { value: "VENDIDO", label: "Vendido", color: "#6366F1" },
    { value: "EXTRAVIADO", label: "Extraviado", color: "#EF4444" },
    { value: "DOADO", label: "Doado", color: "#0891B2" },
    { value: "DESCARTADO", label: "Descartado", color: "#78716C" },
];

// Situações que representam bem baixado
export const SITUACOES_BAIXA = ["BAIXADO", "VENDIDO", "EXTRAVIADO", "DOADO", "DESCARTADO"];

export const isBaixado = (situacao) => SITUACOES_BAIXA.includes(situacao);

// Tipos de baixa aceitos pelo endpoint POST /:id/baixa
export const TIPOS_BAIXA = [
    { value: "DOACAO", label: "Doação", temDestinatario: true },
    { value: "VENDA", label: "Venda", temDestinatario: true },
    { value: "DESCARTE", label: "Descarte", temDestinatario: false },
    { value: "EXTRAVIO", label: "Extravio", temDestinatario: false },
    { value: "OUTRO", label: "Outro", temDestinatario: false },
];

export const getTipoLabel = (tipo) =>
    TIPOS_PATRIMONIO.find((t) => t.value === tipo)?.label || tipo || "-";

export const getSituacaoInfo = (situacao) => {
    const info = SITUACOES_PATRIMONIO.find((s) => s.value === situacao);
    return { label: info?.label || situacao || "-", color: info?.color || "#9CA3AF" };
};

/**
 * Localização atual do bem para exibição:
 * obra vinculada tem prioridade; senão o local; senão "-".
 */
export const getLocalizacaoLabel = (patrimonio) => {
    if (patrimonio?.obra) {
        return `Obra: ${patrimonio.obra.codigoProjeto} - ${patrimonio.obra.nomeProjeto}`;
    }
    if (patrimonio?.local) {
        return patrimonio.local.nome;
    }
    return "-";
};

/** Badge de situação (mesmo padrão visual dos status de Pedido de Compra) */
export const SituacaoBadge = ({ situacao }) => {
    const info = getSituacaoInfo(situacao);
    return (
        <span
            style={{
                padding: "4px 12px",
                borderRadius: "12px",
                fontSize: "12px",
                fontWeight: "600",
                backgroundColor: info.color,
                color: "#FFFFFF",
                display: "inline-block",
                whiteSpace: "nowrap",
            }}
        >
            {info.label}
        </span>
    );
};
